// Web Bluetooth readers for standard GATT health profiles. Chrome/Edge only.
const sfloat = (dv, o) => {
  const raw = dv.getUint16(o, true);
  let mant = raw & 0x0fff, exp = raw >> 12;
  if (exp >= 8) exp -= 16;
  if (mant >= 0x800) mant -= 0x1000;
  return mant * 10 ** exp;
};
const float32 = (dv, o) => {
  const raw = dv.getUint32(o, true);
  let mant = raw & 0x00ffffff, exp = raw >> 24;
  if (exp >= 128) exp -= 256;
  if (mant >= 0x800000) mant -= 0x1000000;
  return mant * 10 ** exp;
};
const r1 = (n) => Math.round(n * 10) / 10;

export const BT_DEVICES = {
  bp: { service: "blood_pressure", char: "blood_pressure_measurement", indicate: true, parse: (dv) => { const f = dv.getUint8(0); const kpa = f & 1; const sys = sfloat(dv, 1), dia = sfloat(dv, 3); let o = 7; if (f & 2) o += 7; const out = { bp: `${Math.round(kpa ? sys * 7.5 : sys)}/${Math.round(kpa ? dia * 7.5 : dia)}` }; if (f & 4) out.pulse = String(Math.round(sfloat(dv, o))); return out; } },
  thermo: { service: "health_thermometer", char: "temperature_measurement", indicate: true, parse: (dv) => { const f = dv.getUint8(0); const v = float32(dv, 1); return { temp: String(r1(f & 1 ? (v - 32) * 5 / 9 : v)) }; } },
  spo2: { service: "pulse_oximeter", char: 0x2a5e, indicate: true, parse: (dv) => ({ spo2: String(Math.round(sfloat(dv, 1))), pulse: String(Math.round(sfloat(dv, 3))) }) },
  glucose: { service: "glucose", char: "glucose_measurement", indicate: true, parse: (dv) => { const f = dv.getUint8(0); let o = 3 + 7 + (f & 1 ? 2 : 0); if (!(f & 2)) return {}; const v = sfloat(dv, o); return { glucose: String(f & 4 ? Math.round(v * 100000) : Math.round(v * 100000 * 18)) }; } },
  scale: { service: "weight_scale", char: "weight_measurement", indicate: true, parse: (dv) => { const f = dv.getUint8(0); const raw = dv.getUint16(1, true); return { weight: String(r1(f & 1 ? raw * 0.01 * 0.4536 : raw * 0.005)) }; } },
  hr: { service: "heart_rate", char: "heart_rate_measurement", indicate: false, parse: (dv) => ({ pulse: String(dv.getUint8(0) & 1 ? dv.getUint16(1, true) : dv.getUint8(1)) }) },
};

export const btSupported = () => typeof navigator !== "undefined" && !!navigator.bluetooth;

export async function readBluetooth(kind, onReading) {
  const cfg = BT_DEVICES[kind];
  const device = await navigator.bluetooth.requestDevice({ filters: [{ services: [cfg.service] }] });
  const server = await device.gatt.connect();
  const svc = await server.getPrimaryService(cfg.service);
  const ch = await svc.getCharacteristic(cfg.char);
  const handler = (e) => { try { const v = cfg.parse(e.target.value); if (Object.keys(v).length) onReading(v, device.name || kind); } catch (err) { console.warn("bt parse", err); } };
  ch.addEventListener("characteristicvaluechanged", handler);
  await ch.startNotifications();
  return () => { try { ch.removeEventListener("characteristicvaluechanged", handler); device.gatt.disconnect(); } catch (e) { /* ignore */ } };
}
